import { addLink, buildCorrelation } from '../..';
import { containsLink } from '../correlation/containsLink';
import { hasLinks } from '../correlation/hasLinks';
export function addSignal(matchedCorrelationIndices, atomType, link, correlations) {
    if (matchedCorrelationIndices.length === 0) {
        // in case of no signal match -> add new signal from 2D
        const newCorrelation = buildCorrelation({
            atomType,
        });
        addLink(newCorrelation, link);
        const pseudoIndex = correlations.findIndex((correlation) => correlation.atomType === atomType &&
            correlation.pseudo &&
            !hasLinks(correlation));
        if (pseudoIndex >= 0) {
            correlations[pseudoIndex] = newCorrelation;
        }
        else {
            correlations.push(newCorrelation);
        }
    }
    else if (!containsLink(correlations[matchedCorrelationIndices[0]], link)) {
        // if allowed then add links from 2D data in first match only
        addLink(correlations[matchedCorrelationIndices[0]], link);
    }
}
//# sourceMappingURL=addSignal.js.map